/*eslint-disable */
import React, { useState } from "react";
import Body from "./Body";
import { render } from "@testing-library/react";

const Dashboard = () => {
  const [isReceiptOpen, setIsReceiptOpen] = useState(false);
  const handleReceiptClick = (row, receiptIndex) => {
    console.log("Clicked receipt", receiptIndex, "for row:", row);
    // Example: open modal, generate receipt PDF, etc.
  };
  const [lineChartData, setLineChartData] = useState([
    { date: "Aug 1", academic: 20000, residential: 50000 },
    { date: "Aug 2", academic: 18000, residential: 45000 },
    { date: "Aug 3", academic: 25000, residential: 40000 },
    { date: "Aug 4", academic: 40000, residential: 45000 },
    { date: "Aug 5", academic: 60000, residential: 50000 },
    { date: "Aug 6", academic: 50000, residential: 20000 },
    { date: "Aug 7", academic: 40000, residential: 25000 },
  ]);
  const [donutChartData1, setDonutChartData1] = useState([
    {
      category: "Payments",
      percentage: 18.43,
      amount: 1251350,
      positionColor: "#26A69A",
    },
    {
      category: "Dividends",
      percentage: 27.06,
      amount: 1837325,
      positionColor: "#42A5F5",
    },
    {
      category: "Educational materials",
      percentage: 18.04,
      amount: 1224890,
      positionColor: "#AB47BC",
    },
    {
      category: "Office supplies",
      percentage: 18.04,
      amount: 1224890,
      positionColor: "#EC407A",
    },
    {
      category: "Electricity",
      percentage: 9.21,
      amount: 625335,
      positionColor: "#FFCA28",
    },
    {
      category: "Activities",
      percentage: 9.21,
      amount: 625335,
      positionColor: "#FF7043",
    },
  ]);
  const [donutChartData2, setDonutChartData2] = useState([
    {
      category: "Payments",
      percentage: 18.18,
      amount: 454500,
      positionColor: "#26A69A",
    },
    {
      category: "Dividends",
      percentage: 27.27,
      amount: 681750,
      positionColor: "#42A5F5",
    },
    {
      category: "Educational materials",
      percentage: 18.18,
      amount: 454500,
      positionColor: "#AB47BC",
    },
    {
      category: "Office supplies",
      percentage: 18.18,
      amount: 454500,
      positionColor: "#EC407A",
    },
    {
      category: "Electricity",
      percentage: 9.09,
      amount: 227250,
      positionColor: "#FFCA28",
    },
    {
      category: "Activities",
      percentage: 9.09,
      amount: 227250,
      positionColor: "#FF7043",
    },
  ]);

  const [barGraphData, setBarGraphData] = useState([
    {
      category: "Salaries",
      amount: 18000,
    },
    {
      category: "Materials & Resources",
      amount: 22000,
    },
    {
      category: "Transportation cost",
      amount: 15000,
    },
    {
      category: "Laboratory and practical cost",
      amount: 20000,
    },
    {
      category: "Library resources",
      amount: 12000,
    },
    {
      category: "Technology e-learning",
      amount: 12000,
    },
    {
      category: "Examination",
      amount: 12000,
    },
    {
      category: "Academic events",
      amount: 18000,
    },
  ]);
  const [barGraphDataResidential, setBarGraphDataResidential] = useState([
    {
      category: "Hostel staff salaries",
      amount: 8000,
    },
    {
      category: "Food & dining",
      amount: 22000,
    },
    {
      category: "Accommodation maintenance",
      amount: 15000,
    },
    {
      category: "Electricity",
      amount: 20000,
    },
    {
      category: "Cleaning & sanitation",
      amount: 15000,
    },
    {
      category: "Other maintenance",
      amount: 15000,
    },
  ]);

  const columns = [
    {
      label: "Receipt Id / Time",
      key: "receiptId",
      render: (row) => (
        <div>
          <div className="font-medium">{row.receiptId}</div>
          <div style={{ color: "var(--tableColor)", fontSize: "12px" }}>
            {row.time}
          </div>
        </div>
      ),
    },
    { label: "Expense Category", key: "expenseCategory" },
    {
      label: "Linked to Correspondence",
      key: "link",
      render: (row) => (
        <a
          href={row.link}
          target="_blank"
          rel="noreferrer"
          className="link-blue"
          style={{ color: "var(--blueColor1)", textDecoration: "none" }}
        >
          Check out 🔗
        </a>
      ),
    },
    {
      label: "Total Amount (INR)",
      key: "totalAmount",
      align: "right",
      render: (row) => <span>₹ {row.totalAmount.toLocaleString()}</span>,
    },
    {
      label: "Paid Expense (INR)",
      key: "paidExpense",
      align: "right",
      render: (row) => (
        <div>
          <div>₹ {row.paidExpense.toLocaleString()}</div>
          <div style={{ color: "var(--greenColor)" }}>{row.paymentMode}</div>
        </div>
      ),
    },
    {
      label: "Pay To (someone/B2B)",
      key: "payTo",
      render: (row) => (
        <div>
          <div className="font-medium">{row.payToName}</div>
          <div className="text-xs text-gray-600">
            Ph:{" "}
            <span style={{ color: "var(--blueColor1)" }}>{row.payToPhone}</span>
          </div>
        </div>
      ),
    },
    {
      label: "Confirmed By",
      key: "confirmedBy",
      render: (row) => (
        <span style={{ color: "var(--greenColor)" }}>{row.confirmedBy}</span>
      ),
    },
    {
      label: "Receipts",
      key: "actions",
      render: (row) => (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <button className="btn-link">Receipt</button>
          {row.status === "due" ? (
            <button className="btn-warning">Pay Due</button>
          ) : (
            <span className="badge-success">All Paid</span>
          )}
        </div>
      ),
    },
  ];

  const data = [
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      expenseCategory: "Salaries",
      link: "/correspondence/23457289056",
      totalAmount: 18000,
      paidExpense: 18000,
      paymentMode: "UPI",
      payToName: "Muklesur Coaching",
      payToPhone: "9876543210",
      confirmedBy: "Jaheer Ahmad",
      status: "due", // or "paid"
    },
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      expenseCategory: "Influencer marketing",
      link: "/correspondence/23457289056",
      totalAmount: 36000,
      paidExpense: 18000,
      paymentMode: "Net banking",
      payToName: "Mahi Enterprise",
      payToPhone: "9876543210",
      confirmedBy: "Jaheer Ahmad",
      status: "paid", // or "due"
    },
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      expenseCategory: "Academic events",
      link: "/correspondence/23457289056",
      totalAmount: 18000,
      paidExpense: 18000,
      paymentMode: "Debit card",
      payToName: "Muklesur Coaching",
      payToPhone: "9876543210",
      confirmedBy: "Jaheer Ahmad",
      status: "due", // or "paid"
    },
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      expenseCategory: "Salaries",
      link: "/correspondence/23457289056",
      totalAmount: 36000,
      paidExpense: 18000,
      paymentMode: "Cash",
      payToName: "Mahi Enterprise",
      payToPhone: "9876543210",
      confirmedBy: "Jaheer Ahmad",
      status: "paid", // or "due"
    },
  ];

  const _this = {
    columns,
    data,
    isReceiptOpen,
    setIsReceiptOpen,
    handleReceiptClick,
    lineChartData,
    barGraphData,
    barGraphDataResidential,
    donutChartData1,
    donutChartData2,
  };
  return <Body {..._this} />;
};

export default Dashboard;
